export default __webpack_public_path__ + "static/media/04.c901da33.png";